class DrivePlan {
	id = '';
	name = '';
	description = '';
	interval = '';
	displayInterval = '';
	amount = 0;
	details = null;
	paymentMethodRequired = false;
	contactForPricing = false;
	customBilling = false;
	active = true;
	hasTrial = false;
	oneTimeOffer = false;
}

export default DrivePlan;



// WEBPACK FOOTER //
// ./src/store/models/drive-plan.js